export default __webpack_public_path__ + "static/media/hkk-logo.5f5ad60c.png";